export default __webpack_public_path__ + "static/media/lifestyleAnalysis1.378a282b.png";